import { configureStore } from '@reduxjs/toolkit';
import navReducer from './slices/navSlice';
import websiteReducer, { setStoreRef } from './slices/websiteSlice';
import settingsReducer from './slices/settingsSlice';
import authReducer from './slices/authSlice';
import onlineWebsitesReducer from './slices/onlineWebsitesSlice';
import hotSearchReducer from './slices/hotSearchSlice';

// 适应扩展环境的环境判断
const getEnvironment = () => {
  // 首先尝试从window对象获取（扩展环境）
  if (typeof window !== 'undefined' && window.NODE_ENV) {
    return window.NODE_ENV;
  }
  // 然后尝试从process.env获取（常规React环境）
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  }
  return 'production';
};

const store = configureStore({
  reducer: {
    nav: navReducer,
    website: websiteReducer,
    settings: settingsReducer,
    auth: authReducer,
    onlineWebsites: onlineWebsitesReducer,
    hotSearch: hotSearchReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: false, // 允许非序列化值，用于特殊场景
    }),
  // 启用 Redux DevTools 扩展
  devTools: getEnvironment() !== 'production',
});

// 设置 store 引用，用于在异步操作中安全地访问 store
setStoreRef(store);

export default store; 